'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { getENV } from '../../utils/env';
type LocalAdScriptsProps = {
  onDone: () => void;
};
export const LocalAdLegacy = t0 => {
  const $ = _c(8);
  const {
    onDone
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getENV("NEXT_PUBLIC_FLIPP_ACCESS_TOKEN");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const accessToken = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getENV("NEXT_PUBLIC_FLIPP_MERCHANT_ID");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const merchantId = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = getENV("NEXT_PUBLIC_FLIPP_MERCHANT_NAME");
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const merchantName = t3;
  let t4;
  if ($[3] !== onDone) {
    t4 = <Script onLoad={onDone} onError={onDone} id="flipp-storefront-script" src={`https://aq.flippenterprise.net/${merchantId}/iframe.js`} />;
    $[3] = onDone;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Script strategy="lazyOnload" id="flipp">{`var flippContainer = document.querySelector("#flipp-container");
                var storefront = new Flipp.Storefront({
                    accessToken: "${accessToken}",
                    merchantId: "${merchantId}",
                    merchantNameIdentifier: "${merchantName}",
                    locale: "en-CA"
                });
                storefront.renderStorefront(flippContainer);`}</Script>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4) {
    t6 = <>{t4}{t5}</>;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
};